import { Directive, HostListener, ElementRef } from '@angular/core';
import { CleanUpVinService } from '../services/cleanUpVin.service';

@Directive({
  selector: '[CleanUpVinDirective]'
})
export class CleanUpVinDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault(); // blocks default paste from clipboard and handles sanitized text

    const pasted = event.clipboardData?.getData('text') || '';
    const cleaned = CleanUpVinService.cleanVin(pasted);

    const input = this.el.nativeElement;
    input.value = cleaned;
    input.dispatchEvent(new Event('input'));
  }
}
